<template>
  <div>
    <el-row v-if="componentShow === 'shopAuditManage'">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <div>查询条件</div>
          </div>
          <div class="">
            <el-form :inline="true" :model="conditions" class="flex justify-start">
              <el-form-item>
                <el-input v-model="conditions.shopName" placeholder="请输入店铺名称" clearable />
              </el-form-item>
              <el-form-item>
                <el-input v-model="conditions.returnPerson" placeholder="请输入退货联系人" clearable />
              </el-form-item>
              <el-form-item>
                <el-input v-model="conditions.returnLink" placeholder="请输入退货联系电话" clearable />
              </el-form-item>
              <el-form-item>
                <el-select v-model="conditions.state" placeholder="请选择审核状态" style="width:100%">
                  <el-option label="请选择审核状态" value="" />
                  <el-option label="待审核" value="001" />
                  <el-option label="审核通过" value="002" />
                  <el-option label="审核不通过" value="003" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="queryShopAuditMethod">
                  查询
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row v-if="componentShow === 'shopAuditManage'">
      <el-col :span="24">
        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <div>店铺审核</div>
          </div>
          <div class="">
            <el-table :data="shopAudits" border style="width: 100%">
              <el-table-column prop="auditId" label="审核ID" align="center" />
              <el-table-column prop="shopName" label="名称" align="center" />
              <el-table-column prop="sendAddress" label="发货地址" align="center" />
              <el-table-column prop="returnPerson" label="退货联系人" align="center" />
              <el-table-column prop="returnLink" label="退货联系电话" align="center" />
              <el-table-column prop="state" label="审核状态" align="center">
                <template slot-scope="scope">
                  {{ auditState(scope.row.state) }}
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="120">
                <template slot-scope="scope">
                  <el-button size="mini" @click="openAuditOpenShopModel(scope.row)">
                    查看
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination :current-page="page" :page-size="rows" :total="total" layout="total, prev, pager, next"
              @current-change="handlePageChange" />
          </div>
        </el-card>
      </el-col>
    </el-row>

    <view-shop-audit-info v-if="componentShow === 'viewShopAuditInfo'" ref="viewShopAuditInfo"
      @refresh="refreshShopAuditManageInfo" />
  </div>
</template>

<script>
import { queryShopAudit } from '@/api/goods/shopAuditApi'
import ViewShopAuditInfo from '@/components/goods/viewShopAuditInfo/viewShopAuditInfo.vue'

export default {
  name: 'ShopAuditManage',
  components: {
    ViewShopAuditInfo
  },
  data() {
    return {
      componentShow: 'shopAuditManage',
      shopAudits: [],
      total: 0,
      page: 1,
      rows: 10,
      conditions: {
        auditId: '',
        storeId: '',
        returnLink: '',
        returnPerson: '',
        shopName: '',
        shopId: '',
        state: ''
      }
    }
  },
  created() {
    let shopId = this.getShopId();
    this.shopId = shopId;
    this.listShopAudits()
  },
  methods: {
    listShopAudits() {
      const params = {
        ...this.conditions,
        page: this.page,
        row: this.rows,
        shopId: this.shopId
      }
      queryShopAudit(params).then(res => {
        this.shopAudits = res.data
        this.total = res.total
      })
    },
    openAuditOpenShopModel(row) {
      console.log(row);
      this.componentShow = 'viewShopAuditInfo'
      this.$refs.viewShopAuditInfo.open(row)
    },
    auditState(state) {
      if (state === '001') return '待审核'
      if (state === '002') return '审核通过'
      if (state === '003') return '审核不通过'
      return ''
    },
    queryShopAuditMethod() {
      this.page = 1
      this.listShopAudits()
    },
    handlePageChange(page) {
      this.page = page
      this.listShopAudits()
    },
    refreshShopAuditManageInfo() {
      this.componentShow = 'shopAuditManage'
      this.listShopAudits()
    }
  }
}
</script>

<style scoped>
.card-body {
  padding: 20px;
}
</style>